<section class="vo-card" aria-labelledby="step21-title">
  <header class="vo-card__head">
    <h2 class="vo-card__title" id="step21-title">Das zu reinigende Objekt</h2>
    <p class="vo-card__sub">Wo soll gereinigt werden?</p>
  </header>

  <form class="vo-grid" [formGroup]="draftInquiryForm" novalidate>
    <div class="vo-field vo-field--full">
      <label class="vo-label" for="from_address">Adresse des Objekts</label>
      <div class="vo-input-icon">
        <app-icon name="map-pin" class="vo-input-icon__icon"/>
        <input #fromAddressInput id="from_address" type="text" class="vo-input" formControlName="from_address"
               placeholder="Strasse &amp; Hausnummer — Adresse suchen" autocomplete="off"
               [class.is-invalid]="hasError('from_address')">
        <app-google-places-autocomplete
          [forInput]="fromAddressInput"
          (placeSelected)="onAddressPlaceSelected($event)"/>
      </div>

      <div class="vo-address__row">
        <div class="vo-address__cell">
          <input #fromZipInput id="from_zip" type="text" class="vo-input" formControlName="from_zip"
                 placeholder="PLZ" aria-label="PLZ" autocomplete="off" [class.is-invalid]="hasError('from_zip')">
          <app-google-places-autocomplete
            [forInput]="fromZipInput"
            [types]="['postal_code']"
            [minQueryLength]="2"
            (placeSelected)="onZipPlaceSelected($event)"/>
        </div>
        <div class="vo-address__cell">
          <input #fromCityInput id="from_city" type="text" class="vo-input" formControlName="from_city"
                 placeholder="Ort" aria-label="Ort" autocomplete="off" [class.is-invalid]="hasError('from_city')">
          <app-google-places-autocomplete
            [forInput]="fromCityInput"
            [types]="['locality']"
            [minQueryLength]="2"
            (placeSelected)="onCityPlaceSelected($event)"/>
        </div>
      </div>

      <p class="vo-error" *ngIf="hasError('from_address') || hasError('from_zip') || hasError('from_city')">
        <app-icon name="circle-alert" [size]="14"/>
        Bitte Strasse und Hausnummer, PLZ und Ort angeben
      </p>
    </div>

    <div class="vo-field vo-field--full">
      <span class="vo-label" id="step21-object-type">Art des Objekts</span>
      <div class="vo-chips" role="group" aria-labelledby="step21-object-type">
        <button *ngFor="let option of objectTypeOptions" type="button" class="vo-chip"
                [class.is-selected]="isObjectTypeActive(option.value)"
                [class.is-invalid]="hasError('from_object_type')"
                [attr.aria-pressed]="isObjectTypeActive(option.value)"
                (click)="selectObjectType(option.value)">
          <app-icon [name]="option.lucideIcon"/>
          {{ option.label }}
        </button>
      </div>
      <p class="vo-error" *ngIf="hasError('from_object_type')">
        <app-icon name="circle-alert" [size]="14"/>
        Bitte wählen Sie eine Option aus
      </p>
    </div>

    <div class="vo-field">
      <label class="vo-label" for="rooms">Anzahl Zimmer</label>
      <select id="rooms" class="vo-select" formControlName="rooms" [class.is-invalid]="hasError('rooms')">
        <option value="" disabled>Bitte wählen</option>
        <option *ngFor="let option of roomOptions" [value]="option">{{ option | inquiryRooms }}</option>
      </select>
      <p class="vo-error" *ngIf="hasError('rooms')">
        <app-icon name="circle-alert" [size]="14"/>
        Bitte wählen Sie eine Option aus
      </p>
    </div>

    <div class="vo-field">
      <label class="vo-label" for="square_meters">Wohnfläche in m²</label>
      <input id="square_meters" type="number" class="vo-input" formControlName="square_meters"
             placeholder="z.B. 75" min="10" max="500" [class.is-invalid]="hasError('square_meters')">
      <p class="vo-error" *ngIf="hasError('square_meters')">
        <app-icon name="circle-alert" [size]="14"/>
        Wohnfläche muss zwischen 10 und 500 m² liegen
      </p>
    </div>
  </form>
</section>

<app-inquiry-step-nav (back)="goBack()" (next)="onSubmit()"/>
